// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS SelectionBubble INSTEAD.
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from "../Icon";
var SelectionBubble = function SelectionBubble(props) {
  var className = props.className,
    id = props.id,
    label = props.label,
    style = props.style,
    title = props.title,
    selected = props.selected,
    hideClose = props.hideClose;
  var selectionBubbleContainerClass = function selectionBubbleContainerClass() {
    return classNames({
      'ui-selection': true
    }, className);
  };
  var onClick = function onClick() {
    props.onClick(selected);
  };
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: selectionBubbleContainerClass(),
    style: style,
    title: title
  }, /*#__PURE__*/React.createElement("div", {
    className: "ui-selection__button-container"
  }, /*#__PURE__*/React.createElement("span", null, label), !hideClose && /*#__PURE__*/React.createElement(Icon, {
    type: "button",
    className: "ui-selection__button",
    "aria-label": "'".concat(label, "'"),
    icon: "IconCross",
    size: 9,
    onClick: onClick
  })));
};
SelectionBubble.propTypes = {
  /** className for reference */
  className: PropTypes.string,
  hideClose: PropTypes.bool,
  /** id for reference */
  id: PropTypes.string,
  /** label text for bubble */
  label: PropTypes.string.isRequired,
  /** Callback function when the cross icon is clicked */
  onClick: PropTypes.func.isRequired,
  /** Override the inline-styles of the root element || Not Recommended */
  style: PropTypes.object,
  /** Selected object represented by bubble */
  selected: PropTypes.object.isRequired,
  /** Message to display when hovering on the cross icon */
  title: PropTypes.string
};
SelectionBubble.defaultProps = {
  id: '',
  className: '',
  style: {},
  title: '',
  hideClose: false
};
export default SelectionBubble;